export const setBaseURLS = (urls) => {
  if (!urls) return new Error("no urls data for set it ..!");
  localStorage.setItem("baseURLS", urls);
};

export const getBaseURLS = () => {
  return process.env.REACT_APP_BASE_URL;
};

export const getBaseUrlB2B = () => {
  return process.env.REACT_APP_BASE_URL_B2B;

}

export const getElasticUrl = () => {
  return process.env.REACT_APP_ELASTICSEARCH_URL;

}
